import styled from 'styled-components';
import { ModalFeatureDetailStyled } from '../../ModalFeatureDetailStyled';
import { rem } from 'polished';

export const ModalFeatureDetailStyledOV = styled(ModalFeatureDetailStyled)`
    
`;
